<template>
    <header :style="{backgroundColor: bg_color, position: hd_position}">
        <!-- <div>
            <div :class="{img_hover: hover_flag}" class="web_icon">
                <img src="../../static/img/logo1.png" alt="官网" @click="toHome" style="height:28px;">
                <span style="padding-left:30px;line-height:30px;font-size:25px;">YOFINE云帆自动化</span>
            </div>
            <ul>
                <li v-for="(item,index) in titleList" :key="index" @click="selected(item.title)">
                    <router-link :to="item.link" :class="{active: active == item.title}">{{ item.title }}</router-link>
                </li>
            </ul>
        </div> -->
        <div class="layout">
            <div class="layout-logo">
                <div style="float:left;margin-left:120px;"><img src="../../static/img/logo1.png" alt="官网" @click="toHome" style="height: 40px;margin-top: 10px;"></div>
                <div style="float:left;margin-left:10px;"><span style="font-size:38px;">秦皇岛云帆</span></div>
            </div>
            <div class="layout-nav">
                <el-menu
                    :default-active="getActiveIndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect"
                    background-color="#008CD5"
                    text-color="#fff"
                    active-text-color="#fff">
                    <el-menu-item index="/home"><i class="el-icon-s-home"/>首页</el-menu-item>
                    <template v-for="(item,index) in titleList">
                        <el-menu-item v-if="!item.subitem" :index="item.link" :key="index"><i :class="item.icon"/>{{ item.title }}</el-menu-item>
                        <el-submenu v-else :index="item.link" :name='item.link' :key="index">
                            <template slot="title">{{ item.title }}</template>
                            <template v-for="(subitem,subindex) in item.subitem">
                                <el-menu-item v-if="!subitem.children" :index="subitem.link" :key="'sub'+subindex">{{ subitem.title }}</el-menu-item>
                                <el-submenu v-else :index="subitem.link" :key="'sub'+subindex">
                                    <template slot="title">{{ subitem.title }}</template>
                                    <el-menu-item v-for="(child,childindex) in subitem.children" :index="child.link" :key="'child'+childindex">{{ child.title }}</el-menu-item>
                                </el-submenu>
                            </template>
                        </el-submenu>
                    </template>
                </el-menu>

           </div>
  <el-button type="primary" @click="submit11">进入物业端</el-button>     
 
           </div>
     


   </div>
    </header>
</template>

<script>
export default {
    name: "Header",
    props:{
        bg_color:{
            type: String,
            default: 'transparent' 
        },
        hd_position:{
            type: String,
            default: 'fixed'
        },
        hover_flag:{
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            activeIndex: '/home',
            active: '首页',
            titleList:[
                /* {
                    title: '首页',
                    link: '/home'
                }, */
                {
                    title: '公司简介',
                    link: '/solution',       // '/solution'
                    icon:'el-icon-s-claim',
                    /* subitem:[
                        {
                            title: '方案一',
                            link: 'solution1'
                        },
                        {
                            title: '方案二',
                            link: 'solution2'
                        },
                        {
                            title: '方案三',
                            link: 'solution3'
                        },
                        {
                            title: '方案四',
                            link: 'solution4'
                        },
                    ]  */
                }, 	
                {
                    title: '产品中心',
                    link: '/product',
                    icon:'el-icon-menu',
                     subitem:[
                        {
                            title: '所有产品',
                            link: 'product'
                        },
                        {
                            title: '主控器',
                            link: 'product2'
                        },
                        {
                            title: '分层器',
                            link: 'product3'
                        },
                        {
                            title: '读卡器',
                            link: 'product4'
                        },{
                            title: '写卡器',
                            link: 'product5'
                        },
                        {
                            title: '语音播报',
                            link: 'product6'
                        },
                        {
                            title: '转换器',
                            link: 'product7'
                        },
                        {
                            title: 'IC卡',
                            link: 'product8'
                        },
                    ] 
                },
               
                {
                    title: '客户案例',
                    link: '/customer',        // '/customer'
                    icon:'el-icon-s-custom',
                     subitem:[
                        {
                            title: '所有项目',
                            link: 'customer'
                        },
                        {
                            title: '东北地区项目',
                            link: 'customer2'
                        },
                        {
                            title: '华北地区项目',
                            link: 'customer3'
                        },
                        {
                            title: '中南地区项目',
                            link: 'customer4'
                        },
                        {
                            title: '华东地区项目',
                            link: 'customer5'
                        },
                        {
                            title: '西南地区项目',
                            link: 'customer6'
                        },{
                            title: '西北地区项目',
                            link: 'customer7'
                        },
                        {
                            title: '国外项目',
                            link: 'customer8'
                        },
                        
                    ]  
                },
//              {
//                  title: '关于我们',
//                  link: '#',       // '/about'
//                  icon:'el-icon-info',
//              },
                  {
                    title: '企业新闻',
                     link: '/questionnaire',         // '/about'
                    icon:'el-icon-info',
                },

                  
                
                /* {
                    title: '500',
                    link: '/error-500'
                } */
            ]

        }
    },
    computed: {
      getActiveIndex(){
        return this.$store.state.activeMenuIndex;
      },
    },
    mounted(){
        this.active = this.$route.meta.nav;
        //点击submenu时触发
        /* let list = document.getElementsByClassName('el-submenu');
        var vm = this;
        for(var i=0;i<list.length;i++){
            list[i].onclick=function(e){
                var fname = e.target.childNodes[0].data;
                if(fname == '产品中心'){
                    vm.activeIndex = '/product';
                    vm.$router.push('/product');
                }else if(fname == '解决方案'){
                    vm.activeIndex = '/solution';
                    vm.$router.push('/solution');
                }else if(fname == '客户案例'){
                    vm.activeIndex = '/customer';
                    vm.$router.push('/customer');
                }
            }
        } */
    },
    methods: {
        handleSelect(key, keyPath) {
            this.$router.push(key);
        },
        selected(title){
            this.active = title;
        },
        toHome(){
            this.$router.push('/home');
            this.active = '首页';
        },
        submit11(){
        	 window.location.href = 'http://qr.qp.ink:8080/Yofine/Village.do'
        	
        }
    }
};
</script>

<style lang="scss" scoped>
    .layout{
        background: #008CD5;
        .el-menu--horizontal>.el-submenu .el-submenu__title{ // 导航标题
            height: 60px;
            line-height: 60px;
        }
        .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{ // 被选中的导航标题
            border-bottom: 0 ;
        }
        .el-menu--horizontal>.el-submenu{ // 为了让所有标题靠右，现将导航数组倒序，然后右对齐
            float: right;
        }
        .el-menu.el-menu--horizontal{
            border-bottom: 0 ;
        }
        /deep/ .el-submenu__title i{
            color:#fff;
        }
        /deep/ .el-menu-item i{
            color:#fff;
        }
        .layout-logo{
            width: 420px;
            height: 60px;
            line-height: 60px;
            float: left;
        }
        .layout-nav{
            margin-right: 10%;
            float:left;
        }
    }
    

    
    $white: #ffffff;
    @mixin rim {
        background: transparent none repeat scroll 0 0;
        content: "";
        height: 10px;
        position: absolute;
        width: 25px;
        visibility: hidden;
        transition: .3s ease;
        opacity: 0;
    }
    header {
        color: $white;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999;
        width: 100%;
        padding: 0;//1% 0;
        transition: background-color 1.5s;
        &>div {
            display: flex;
            justify-content: space-between;
            margin: 0;//0 10%;
            .img_hover:hover {
                &::before {
                    content: "";
                    height: 555px;
                    width: 100%;
                    position: absolute;
                    left: 0%;
                    top: 0;
                    background-color: transparent;
                    background-image: -webkit-linear-gradient(-30deg, transparent 30%, #fff 50%, transparent 70%); /*设置渐变的背景，按对角线渐变*/
                    background-blend-mode: hard-light; /*设置背景为混合模式下的强光模式*/
                    background-size: 200%;
                    animation: shine 5s forwards; /*给背景添加动画改变位置*/
                }
            }
            .web_icon {
                img {
                    position: absolute;
                    z-index: inherit;
                    cursor: pointer;
                }
            }
            ul {
                font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
                font-weight: bold;
                display: flex;
                list-style: none;
                li {
                    // margin-right: 5px;
                    box-sizing: border-box;
                    position: relative;
                    a {
                        display: block;
                        line-height: 20px;
                        padding: 6px 15px;
                        text-decoration:none;
                        box-sizing: border-box;
                        color: $white;
                        position: relative;
                        background-color: transparent;
                        text-transform: uppercase;
                        transition: .3s ease;
                        &.active {
                            color: #0053D4;//008CD5;
                            &::before {
                                visibility: visible;
                                opacity: 1;
                                left: 0;
                            }
                            &::after {
                                visibility: visible;
                                opacity: 1;
                                right: 0;
                            }
                        }
                        &:hover {
                            background: none;
                            color: #0053D4;//008CD5;
                            outline: none;
                            &::before {
                                visibility: visible;
                                opacity: 1;
                                left: 0;
                            }
                            &::after {
                                visibility: visible;
                                opacity: 1;
                                right: 0;
                            }
                        }
                        &::before{
                            @include rim;
                            border-left: 1px solid #0053D4;//008CD5;
                            border-top: 1px solid #0053D4;//008CD5;
                            top: 0;
                            left: -70px;
                        }
                        &::after {
                            @include rim;
                            border-right: 1px solid #0053D4;//008CD5;
                            border-bottom: 1px solid #0053D4;//008CD5;
                            bottom: 0;
                            right: 70px;
                        }
                    }
                }
            }
        }
    }
// 动画
@keyframes shine {
    from {background-position: 130%;}
    to {background-position: -50%;}
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue